<template>
     <div class="modal-card ">
        <b-loading  :active.sync="isFullScreenLoading" ></b-loading>
                <header class="modal-card-head"  >

                    <p class="modal-card-title "   >UA Management</p>
 

                </header>
                <section class="modal-card-body"  >
                     
                   <b-tabs v-model="activeTab" size="is-large" >
                        <b-tab-item label="Color" >
                            <nav class="level is-mobile">
                                <div class="level-left">
                                    <div class="level-item">
                                        <b-button
                                                  type="is-success"
                                                  icon-left="plus"
                                                  @click="addNewColor">
                                            Add New Color
                                        </b-button>
                                    </div>
                                    <div class="level-item">
                                         <b-button
                                            type="is-primary"
                                            icon-left="refresh"
                                            @click="loadColorData"
                                    >Refresh Color</b-button>
                                    </div>

                                </div>
                                <div class="level-right">

                                </div>
                            </nav>


                            <b-table
                                    :data="isEmpty ? [] : colorData"
                                    bordered
                                    striped
                                    narrowed
                                    hoverable
                                    focusable
                                    :loading = "isColorLoading"
                                    mobile-cards>
                                <b-table-column   label="Name" v-slot="props" width="40%">
                                    {{ props.row.name }}
                                </b-table-column>
                                <b-table-column   label="Status" v-slot="props">
                                       <b-icon
                                            :icon="props.row.enabled ? `check-circle` : `stop-circle` "
                                            :type="props.row.enabled ? `is-success` : `is-danger` "
                                            size="is-medium">
                                      </b-icon>

                                      {{props.row.enabled ? 'ใช้งาน' : 'ยกเลิก'}}
                                </b-table-column>
                                <b-table-column   label="#"     centered v-slot="props">
                                    <b-button type="is-warning"  
                                              icon-left="pencil" 
                                               @click="editColor(props.row) "
                                              >
                                              Edit
                                    </b-button>
                                </b-table-column>


                                <template slot="empty">
                                    <section class="section">
                                        <div class="content has-text-grey has-text-centered">
                                            <p>
                                                <b-icon
                                                        icon="emoticon-sad"
                                                        size="is-large">
                                                </b-icon>
                                            </p>
                                            <p>Nothing here.</p>
                                        </div>
                                    </section>
                                </template>
                            </b-table>



                        </b-tab-item>







                        <b-tab-item label="Technique">
                           

                           <nav class="level is-mobile">
                                <div class="level-left">
                                    <div class="level-item">
                                        <b-button
                                                  type="is-success"
                                                  icon-left="plus"
                                                  @click="addNewTechnique">
                                            Add New Technique
                                        </b-button>
                                    </div>
                                    <div class="level-item">
                                         <b-button
                                            type="is-primary"
                                            icon-left="refresh"
                                            @click="loadTechniqueData"
                                    >Refresh Technique</b-button>
                                    </div>

                                </div>
                                <div class="level-right">

                                </div>
                            </nav>


                            <b-table
                                    :data="isEmpty ? [] : techniqueData"
                                    bordered
                                    striped
                                    narrowed
                                    hoverable
                                    focusable
                                    :loading = "isTechniqueLoading"
                                    mobile-cards>
                                <b-table-column   label="Name" v-slot="props" width="40%">
                                    {{ props.row.name }}
                                </b-table-column>
                                <b-table-column   label="Status" v-slot="props">
                                       <b-icon
                                            :icon="props.row.enabled ? `check-circle` : `stop-circle` "
                                            :type="props.row.enabled ? `is-success` : `is-danger` "
                                            size="is-medium">
                                      </b-icon>

                                      {{props.row.enabled ? 'ใช้งาน' : 'ยกเลิก'}}
                                </b-table-column>

                                <b-table-column   label="#"     centered v-slot="props">
                                    <b-button type="is-warning"  icon-left="pencil" @click="editTechnique(props.row)">Edit</b-button>
                                </b-table-column>


                                <template slot="empty">
                                    <section class="section">
                                        <div class="content has-text-grey has-text-centered">
                                            <p>
                                                <b-icon
                                                        icon="emoticon-sad"
                                                        size="is-large">
                                                </b-icon>
                                            </p>
                                            <p>Nothing here.</p>
                                        </div>
                                    </section>
                                </template>
                            </b-table>




                        </b-tab-item>










                        <b-tab-item label="Transparent">
                             <nav class="level is-mobile">
                                <div class="level-left">
                                    <div class="level-item">
                                        <b-button
                                                  type="is-success"
                                                  icon-left="plus"
                                                  @click="addNewTransparent">
                                            Add New Transparent
                                        </b-button>
                                    </div>
                                    <div class="level-item">
                                         <b-button
                                            type="is-primary"
                                            icon-left="refresh"
                                            @click="loadTransparentData"
                                    >Refresh Transparent</b-button>
                                    </div>

                                </div>
                                <div class="level-right">

                                </div>
                            </nav>


                            <b-table
                                    :data="isEmpty ? [] : transparentData"
                                    bordered
                                    striped
                                    narrowed
                                    hoverable
                                    focusable
                                    :loading = "isTransparentLoading"
                                    mobile-cards>
                                <b-table-column   label="Name" v-slot="props" width="40%">
                                    {{ props.row.name }}
                                </b-table-column>
                                <b-table-column   label="Status" v-slot="props">
                                       <b-icon
                                            :icon="props.row.enabled ? `check-circle` : `stop-circle` "
                                            :type="props.row.enabled ? `is-success` : `is-danger` "
                                            size="is-medium">
                                      </b-icon>

                                      {{props.row.enabled ? 'ใช้งาน' : 'ยกเลิก'}}
                                </b-table-column>

                                <b-table-column   label="#"     centered v-slot="props">
                                    <b-button type="is-warning"  icon-left="pencil" @click="editTransparent(props.row)">Edit</b-button>
                                </b-table-column>


                                <template slot="empty">
                                    <section class="section">
                                        <div class="content has-text-grey has-text-centered">
                                            <p>
                                                <b-icon
                                                        icon="emoticon-sad"
                                                        size="is-large">
                                                </b-icon>
                                            </p>
                                            <p>Nothing here.</p>
                                        </div>
                                    </section>
                                </template>
                            </b-table>
                        </b-tab-item>
                   </b-tabs>    





                </section>
                <footer class="modal-card-foot">

                    <b-button size="is-medium" type="is-danger"
                              icon-left="close" @click="close">
                        Close
                    </b-button>
                </footer>


               <AddEditColorTechniqueTransparent
                    v-if="isAddEditColorTechniqueTransparentShowing"
                    :type_AddEditColorTechniqueTransparent="type_AddEditColorTechniqueTransparent"
                    :dataAddEditColorTechniqueTransparentToEdit = "dataAddEditColorTechniqueTransparentToEdit"
                    :mode = "addEditColorTechniqueTransparentMode"
                    @close="closeAddEditColorTechniqueTransparent"
                    @closeWithDataChange = "closeAddEditColorTechniqueTransparent_WithChange"
                />



    </div>
</template>



<script>

import axios from "axios";
import { getBaseURLforBackEnd ,getConfigAxios  }  from '@/utils.js'
import { mapState } from "vuex";
import AddEditColorTechniqueTransparent from './AddEditColorTechniqueTransparent.vue'



export default {
    name :"UADashboard1",
    components:{
      AddEditColorTechniqueTransparent,
    },
    computed:{
          ...mapState({
                access_token : state => state.master_data.access_token,
            }) 
    },
    methods:{
        closeAddEditColorTechniqueTransparent(){
               this.isAddEditColorTechniqueTransparentShowing = false
        }, 
        closeAddEditColorTechniqueTransparent_WithChange(payload){
                //  'color','technique','transparent
                if(payload == 'color'){
                  this.loadColorData()
                }
                if(payload == 'technique'){
                  this.loadTechniqueData()  
                }
                if(payload == 'transparent'){
                   this.loadTransparentData()   
                }
                this.isAddEditColorTechniqueTransparentShowing = false
        },
        close(){
           this.$emit('close')
        },


        editTransparent(payload){
            //  console.log(payload)
            this.dataAddEditColorTechniqueTransparentToEdit = Object.assign({},
                                                                                {   
                                                                                    "id" : payload.id,
                                                                                    "name": payload.name,
                                                                                    "enabled" : payload.enabled
                                                                                }
                                                                        )
            this.addEditColorTechniqueTransparentMode = 1 // 0 == add , 1 == edit 
            this.type_AddEditColorTechniqueTransparent = 'transparent'  // 'color','technique','transparent'
            this.isAddEditColorTechniqueTransparentShowing = true
        
        },
        addNewTransparent(){
               this.dataAddEditColorTechniqueTransparentToEdit = Object.assign({},
                                                                            {   
                                                                                "id" : null,
                                                                                "name": "" ,
                                                                                "enabled" : true 
                                                                            }
                                                                    )
                this.addEditColorTechniqueTransparentMode = 0 // 0 == add , 1 == edit 
                this.type_AddEditColorTechniqueTransparent = 'transparent' // 'color','technique','transparent'
                this.isAddEditColorTechniqueTransparentShowing = true
        
        },
        loadTransparentData(){
                this.isTransparentLoading = true
                const datTo = {   
                                    "admin": true 
                               }
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/get_ua_transparent_mst`,datTo,getConfigAxios())
                        .then((res)=>{
                              this.transparentData = res.data
                              this.isTransparentLoading = false
                        })
                        .catch((err)=>{
                            this.isTransparentLoading = false
                            this.$buefy.dialog.alert({
                                title: 'Error',
                                message: `${err}`,
                                type: 'is-danger',
                                hasIcon: true,
                                icon: 'alert-circle',
                                ariaRole: 'alertdialog',
                                ariaModal: true
                            })
                            this.$router.push('/login')
                                .catch(()=>{});
                        })
        },





        editTechnique(payload){
            //  console.log(payload)
            this.dataAddEditColorTechniqueTransparentToEdit = Object.assign({},
                                                                                {   
                                                                                    "id" : payload.id,
                                                                                    "name": payload.name,
                                                                                    "enabled" : payload.enabled
                                                                                }
                                                                        )
            this.addEditColorTechniqueTransparentMode = 1 // 0 == add , 1 == edit 
            this.type_AddEditColorTechniqueTransparent = 'technique'  // 'color','technique','transparent'
            this.isAddEditColorTechniqueTransparentShowing = true
       
        },
        addNewTechnique(){
                this.dataAddEditColorTechniqueTransparentToEdit = Object.assign({},
                                                                            {   
                                                                                "id" : null,
                                                                                "name": "" ,
                                                                                "enabled" : true 
                                                                            }
                                                                    )
                this.addEditColorTechniqueTransparentMode = 0 // 0 == add , 1 == edit 
                this.type_AddEditColorTechniqueTransparent = 'technique' // 'color','technique','transparent'
                this.isAddEditColorTechniqueTransparentShowing = true
     
        },
        loadTechniqueData(){
                this.isTechniqueLoading = true
                const datTo = {   
                                    "admin": true 
                               }
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/get_ua_technique_mst`,datTo,getConfigAxios())
                        .then((res)=>{
                              this.techniqueData = res.data
                              this.isTechniqueLoading = false
                        })
                        .catch((err)=>{
                            this.isTechniqueLoading = false
                            this.$buefy.dialog.alert({
                                title: 'Error',
                                message: `${err}`,
                                type: 'is-danger',
                                hasIcon: true,
                                icon: 'alert-circle',
                                ariaRole: 'alertdialog',
                                ariaModal: true
                            })
                            this.$router.push('/login')
                                .catch(()=>{});
                        })
        },





        editColor(payload){
            //    console.log(payload)
            this.dataAddEditColorTechniqueTransparentToEdit = Object.assign({},
                                                                                {   
                                                                                    "id" : payload.id,
                                                                                    "name": payload.name,
                                                                                    "enabled" : payload.enabled
                                                                                }
                                                                        )
            this.addEditColorTechniqueTransparentMode = 1 // 0 == add , 1 == edit 
            this.type_AddEditColorTechniqueTransparent = 'color'  // 'color','technique','transparent'
            this.isAddEditColorTechniqueTransparentShowing = true
        },
        addNewColor(){
               this.dataAddEditColorTechniqueTransparentToEdit = Object.assign({},
                                                                            {   
                                                                                "id" : null,
                                                                                "name": "" ,
                                                                                "enabled" : true 
                                                                            }
                                                                    )
                this.addEditColorTechniqueTransparentMode = 0 // 0 == add , 1 == edit 
                this.type_AddEditColorTechniqueTransparent = 'color' // 'color','technique','transparent'
                this.isAddEditColorTechniqueTransparentShowing = true
        },
        loadColorData(){
                this.isColorLoading = true
                const datTo = {   
                                    "admin": true 
                               }
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/get_ua_color_mst`,datTo,getConfigAxios())
                        .then((res)=>{
                              this.colorData = res.data
                              this.isColorLoading = false
                        })
                        .catch((err)=>{
                            this.isColorLoading = false
                            this.$buefy.dialog.alert({
                                title: 'Error',
                                message: `${err}`,
                                type: 'is-danger',
                                hasIcon: true,
                                icon: 'alert-circle',
                                ariaRole: 'alertdialog',
                                ariaModal: true
                            })
                            this.$router.push('/login')
                                .catch(()=>{});
                        })
        },




    },
    data(){
        return {
            isFullScreenLoading : false,
            isColorLoading : false,
            isTechniqueLoading : false,
            isTransparentLoading : false,

            activeTab : 0,
            isEmpty : false,

            colorData : [],
            techniqueData : [],
            transparentData : [],

            isAddEditColorTechniqueTransparentShowing : false,
            dataAddEditColorTechniqueTransparentToEdit: {},
            addEditColorTechniqueTransparentMode : 0 , // 0 == add , 1 == edit
            type_AddEditColorTechniqueTransparent : "",
        }
    },
}
</script>